import React from "react";
import PropTypes from "prop-types";
import { IconSvgPaths } from "@alternative/icons";
import classNames from "classnames";

export const Icon = (props) => {
  const { icon: iconName, className, color, ...otherprops } = props;
  const pathStrings = IconSvgPaths[iconName];
  const paths = pathStrings && pathStrings.map((d, i) => <path fillRule="evenodd" clipRule="evenodd" key={i} d={d} />);
  if (!iconName) return null;
  return (
    <span {...otherprops} className={classNames("at-icon", className)} style={{ color: color }}>
      <svg viewBox="0 0 24 24" fill="currentColor">
        {paths}
      </svg>
    </span>
  );
};

Icon.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
};
Icon.defaultProps = {
  color: "",
};
